module.exports = __webpack_public_path__ + "assets/media/lunch.a38681be.mp3";